import type { MetadataError } from '@/graphql/saleor/api';

import type { FormattedError } from './common';
import { commonErrorCodeMessages } from './common';

export const getMetadataCodeMessage = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  error: FormattedError<MetadataError>,
) => commonErrorCodeMessages.unexpectedErrorOccurred;
